export default {
    periods: [],
    activePeriod: {},
    managePeriodDialog: false,
    deletePeriodDialog: false
}
